import * as React from "react";
import styled, { css } from "react-emotion";
import { primaryColors, greyColors } from "../theme/colors";
import { spacing, breakpoints } from "../theme/layout";
import { h3, paragraph, small } from "../theme/typefaces";
import { H3 } from "../theme/text";
import { Icon } from "../theme/icons/index";
import Link from "next/link";
import * as ReactModal from "react-modal";
import { Modal, modalOverlayStyle, reactModalStyle } from "./Modals";
import slugify from "slugify";
import { spaces } from "../theme/layout/spacing";
/** Card Wrapper */
export const cardsWrapperStyle = css `
  display: flex;
  flex-wrap: wrap;
  ${spacing.pt2};
  ${spacing.pb4};
  ${breakpoints.medium `
    margin: 0 -${spaces[1]}px 0 -${spaces[1]}px;
  `};
`;
export const CardsWrapper = ({ children }) => (<div className={cardsWrapperStyle}>{children}</div>);
/** Cards */
export const CardContainer = styled("div") `
  width: 100%;
  display: flex;
  ${breakpoints.medium `
    flex: 0 0 50%;
    max-width: 50%;
  `};
  ${breakpoints.large `
    flex: 0 0 33.33%;
    max-width: 33.33%;
  `};
  ${breakpoints.xlarge `
    flex: 0 0 25%;
    max-width: 25%;
  `};
`;
export const cardStyle = css `
  ${spacing.ml0};
  ${spacing.mr0};
  ${spacing.mv1};
  box-sizing: border-box;
  color: ${primaryColors.darkGrey};
  background-color: ${greyColors["50"]};
  cursor: pointer;
  flex-grow: 1;
  display: flex;

  & a,
  button {
    padding: 24px;
    display: flex;
    box-sizing: border-box;
    transition: box-shadow 0.3s;
    max-width: 100%;
    text-align: left;
    flex-grow: 1;

    &:hover,
    :focus {
      box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.25);
    }
    ${breakpoints.small `
      flex-direction: column;
      align-items: flex-start;
    `};
  }

  & h3 {
    ${h3};
    ${spacing.mt0};
    ${spacing.mh0};
    ${spacing.mb1};
    ${spacing.pa0};
  }

  ${breakpoints.smallDown `
    & h3 {
      ${spacing.mb0};
    }
  `};

  ${breakpoints.medium `
    ${spacing.mh1}
  `};
`;
const cardMetaStyle = css `
  ${small};
  ${spacing.mt0};
  ${spacing.mh0};
  ${spacing.mv1};
  ${spacing.pa0};
  color: ${greyColors[600]};
  width: 100%;
  display: none;
  ${breakpoints.small `
    display: block;
  `};
`;
const cardTextStyle = css `
  ${spacing.mt1};
  ${paragraph};
  color: ${primaryColors.darkGrey};
  line-height: 1.6875em;
  height: 5.0625em; // line-height * 3 (number of lines)
  display: none;
  overflow: hidden;
  width: 100%;
  flex-grow: 1;
  ${breakpoints.small `
    display: block;
  `};
`;
export const cardIcon = css `
  color: ${primaryColors.zuerichBlue};
  font-size: 1.2em;
  margin-left: auto;
  ${breakpoints.small `
    ${spacing.pt2};
    margin-left: 0;
  `};
`;
/** Link Card */
export const LinkCard = ({ title, url, meta, backgroundColor, icon, text }) => (<CardContainer>
    <div className={cardStyle} style={{ backgroundColor }}>
      <Link href={url}>
        <a className={css `
            all: unset;
            display: block;
            border: none;
            text-decoration: none;
            width: 100%;
          `}>
          <H3>{title}</H3>
          {meta && <p className={cardMetaStyle}>{meta}</p>}
          {text && <p className={cardTextStyle}>{text}</p>}
          {icon && (<div className={cardIcon}>
              <Icon name={icon}/>
            </div>)}
        </a>
      </Link>
    </div>
  </CardContainer>);
export class ModalCard extends React.Component {
    constructor(props) {
        super(props);
        this.onOpenModal = () => {
            this.setState({
                showModal: true
            });
        };
        this.onCloseModal = () => {
            this.setState({ showModal: false });
        };
        this.state = {
            showModal: false
        };
    }
    render() {
        const { title, meta, icon, text, children } = this.props;
        return (<CardContainer>
        <div className={cardStyle}>
          <button id={`glossar-card-${slugify(title)}`} className={css `
              all: unset;
              border: none;
              text-decoration: none;
              width: 100%;
            `} onClick={this.onOpenModal}>
            <H3>{title}</H3>
            {meta && <div className={cardMetaStyle}>{meta}</div>}
            {text && <p className={cardTextStyle}>{text}</p>}
            {icon && (<div className={cardIcon}>
                <Icon name={icon}/>
              </div>)}
          </button>
          <ReactModal isOpen={this.state.showModal} contentLabel={`Glossareintrag ${title}`} role="dialog" aria={{
            labelledby: `glossar-card-${slugify(title)}`
        }} shouldCloseOnEsc={true} shouldCloseOnOverlayClick={true} onRequestClose={this.onCloseModal} className={reactModalStyle} overlayClassName={modalOverlayStyle}>
            <Modal mainHeading={title} onClose={this.onCloseModal}>
              {children}
            </Modal>
          </ReactModal>
        </div>
      </CardContainer>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Cards.tsx